// @ts-nocheck
import {useQuery} from "@tanstack/react-query";
import {hotGamesService} from "../../services/games/gamesList/hotGames.service";

export const useGetHotGames = () => {
  const {data, isPending} = useQuery({
    queryKey: ["hotGames"],
    queryFn: () => hotGamesService(),
    select: responseData => {
      const gamesList = responseData?.data?.data?.games || [];
      return gamesList.map((game, index) => ({
        ...game,
        uniqueId: `hot-${game.id || "game"}-${game.provider || "provider"}-${index}`,
      }));
    },
  });

  return {
    games: data || [],
    isPending,
  };
};
